import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { persistor, store } from "../../redux/store";
import { authSlice } from "../../redux/slice/persist/authSlice";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

const handleLogout = async () => {
  await signOut();
  persistor.purge();

  store.dispatch(authSlice.actions.logout());

  store.dispatch(apiConfig.util.resetApiState());
  window.location.href = "/login";
};

export const apiConfig = createApi({
  reducerPath: "apiConfig",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_SERVER_URL,
    prepareHeaders: async (headers, { getState }) => {
      try {
        const fetchAuthSessionOutput = await fetchAuthSession();

        headers.set(
          "Authorization",
          `Bearer ${fetchAuthSessionOutput.tokens?.accessToken}`
        );
        return headers;
      } catch (error: any) {
        console.log(error);

        let message = "Unknown Error";

        if (error instanceof Error) message = error.name;
        if (message.includes("NotAuthorizedException")) {
          await handleLogout();
        }
      }
    },
  }),
  endpoints: () => ({}),
  tagTypes: ["Brand", "Family", "Model", "Firmware", "Template", "File"],
});

export default apiConfig;
